import React from 'react';

import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import Checkbox from '@ui/inputs/Checkbox';

const FormCheckbox = ({ name, label, disabled, defaultValue, ...rest }) => {
    const formContext = useFormContext();

    return (
        <Controller
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                return (
                    <Checkbox
                        onChange={onChange}
                        checked={value}
                        label={label}
                        disabled={disabled}
                        error={error}
                        {...rest}
                    />
                );
            }}
            name={name}
            control={formContext.control}
            defaultValue={defaultValue || false}
        />
    );
};

FormCheckbox.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default FormCheckbox;
